import { render, staticRenderFns } from "./DownloadOnAppstore.vue?vue&type=template&id=1ed5a110&scoped=true"
import script from "./DownloadOnAppstore.vue?vue&type=script&lang=js"
export * from "./DownloadOnAppstore.vue?vue&type=script&lang=js"
import style0 from "./DownloadOnAppstore.vue?vue&type=style&index=0&id=1ed5a110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5a110",
  null
  
)

export default component.exports